import request from '@/utils/axios'
import { system } from './common'

let base = '/backend/auth'
let base2 = '/backend/sys'

/*
 * 根据用户名明码登录
 */
export const loginByUsername = params => {
    return request({
        url: `${base}/user/pwd/signin`,
        headers: {
            Authorization: 'Basic Y2xvdWRhcHA6MTIzNDU2',
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        transformRequest: [
            function(data) {
                let ret = ''
                for (let it in data) {
                    ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
                }
                return ret
            }
        ],
        method: 'post',
        data: params
    })
}

/*
 * 登出,清除token
 * @param accessToken
 * @param refreshToken
 */
export const logout = () => {
    return request({
        url: `${base}/user/common/loginOut`,
        method: 'post'
    })
}

/*
 * 获取用户信息
 * @param NotNeedErrorMessage 不需要默认的错误提示（by meijiangshun）登录的时候需要设置为true
 * @returns {*}
 */
export const getUserInfo = (NotNeedErrorMessage = false) => {
    return request({
        url: `${base2}${system}/user/getCurrentSysuser`,
        headers: {
            ...(NotNeedErrorMessage ? { 'NotNeedErrorMessage': true } : {})
        },
        method: 'get'
    })
}

/**
 * 刷新Token
 */
export const refreshToken = params => {
    return request({
        url: `${base}/user/common/refreshToken`,
        method: 'post',
        headers: {
            Authorization: 'Basic Y2xvdWRhcHA6MTIzNDU2',
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        transformRequest: [
            function(data) {
                let ret = ''
                for (let it in data) {
                    ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
                }
                return ret
            }
        ],
        data: params
    })
}

/*
 * 微信扫码登录 by meijiangshun
 */
export const getAccessTokenForWXLogin = params => {
    return request({
          url: `${base}/user/oauth2code/wechat/getAccessTokenWithoutInitUser`,
        headers: {
            Authorization: 'Basic Y2xvdWRhcHA6MTIzNDU2',
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        transformRequest: [
            function(data) {
                let ret = ''
                for (let it in data) {
                    ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
                }
                return ret
            }
        ],
        method: 'post',
        data: params
    })
}

/**
 * 微信扫码注册
 */
export const getAccessTokenForWXRegister = params => {
  return request({
    url: `${base}/user/oauth2code/wechat/getAccessToken`,
    headers: {
      Authorization: 'Basic Y2xvdWRhcHA6MTIzNDU2',
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    transformRequest: [
      function(data) {
        let ret = ''
        for (let it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        return ret
      }
    ],
    method: 'post',
    data: params
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js